export const LOAD_MORE_LOGS = 'LOAD_MORE_LOGS';

// Log console
export const loadMoreLogs = (page) => ({
  type: LOAD_MORE_LOGS,
  page
});

// Filters
export const CHANGE_FILTER = 'CHANGE_FILTER';

export const changeFilter = (filter) => ({
  type: CHANGE_FILTER,
  filter
});
